// extracted by mini-css-extract-plugin
export default {"title":"LmNd4","titleChild":"zpEel"};